import { PhoneMockups } from "./PhoneMockups"
import { useNavigate } from "react-router-dom"


export const HeroSection = () => {
    const navigate = useNavigate()
    return (
        <section className="pt-32 pb-20 px-6 text-black overflow-hidden">
            <div className="max-w-7xl mx-auto text-center">
                <div className="inline-block mb-4 px-4 py-1 bg-gray-100 rounded-full text-sm">
                    Your digital identity, simplified
                </div>
                <h1 className=" text-5xl md:text-7xl font-semibold mb-6">
                    All Your Links in<br />One Place
                </h1>
                <p className="text-gray-600 text-lg md:text-xl max-w-2xl mx-auto mb-12">
                    No more fumbling with multiple links. Create a beautiful, customizable page that houses all your important links in one place.
                </p>
                <PhoneMockups />
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button className="bg-black text-white px-8 py-4 rounded-full hover:bg-gray-800 transition-colors" onClick={() => { navigate("/signup") }}>
                        Get Started Free
                    </button>
                    <button className="px-8 py-4 rounded-full border border-gray-200 hover:border-gray-300 transition-colors">
                        See Examples
                    </button>
                </div>
            </div>
        </section>
    )
}